module.exports = "<!-- <div lf-update-notification></div> -->\n<div status-nav></div>\n<fb-fact options=\"{window:true}\" fact=\"$ctrl.fact\" case=\"$ctrl.currentCase.data\" on-update=\"$ctrl.addFact(newFact)\" on-next=\"$ctrl.showFact(next, newFact)\" on-toggle-cases=\"$ctrl.toggleCases()\" on-cancel=\"$dismiss()\" on-open-case=\"$ctrl.openCase()\"></fb-fact>\n<lf-case-list route=\"fact\" case=\"$ctrl.currentCase.data\"></lf-case-list>\n"


//////////////////
// WEBPACK FOOTER
// ./project/pages/fact/fact.html
// module id = 879
// module chunks = 3